export const clubSchema = {
	schema: {
		title: 'club schema',
		description: 'Club Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			clubid_c: {
				type: 'string',
			},
			clublocation_c: {
				type: 'string',
			},
			assigned_cmdi_c: {
				type: 'string',
			},
		},
		required: ['id', 'sfid', 'name', 'clubid_c', 'clublocation_c', 'assigned_cmdi_c'],
	},
};
